/**
 * Slugify a human-facing view name into a valid run_pipelines fragment op id.
 *
 * A fragment name is used as a pipeline-step `op`, so it must match the same
 * identifier grammar the backend enforces: `/^[A-Za-z_][A-Za-z0-9_]*$/`.
 *
 * Transform:
 *  - lowercase
 *  - spaces and dashes → `_`
 *  - any other invalid char stripped
 *  - runs of `_` collapsed to a single `_`
 *  - if the result is empty or starts with a digit, prefix `view_`
 */
export function toFragmentName(viewName: string): string {
  const slug = viewName
    .toLowerCase()
    .replace(/[\s-]+/g, '_')
    .replace(/[^a-z0-9_]/g, '')
    .replace(/_+/g, '_');

  if (slug === '' || /^[0-9]/.test(slug)) {
    return `view_${slug}`;
  }
  return slug;
}
